import { NAME as namespace } from './constants';
import { digitalOrdersReducer as reducer } from './reducer';
export var digitalOrders = {
  namespace: namespace,
  reducer: reducer
};
export default digitalOrders;